import { gql } from '@apollo/client/core';

/** The selection list matches `Presale.fromGql`'s `take` list exactly — see `Presale.ts`. */
export const PRESALE_FIELDS = gql`
  fragment PresaleFields on Presale {
    id
    eventId
    name
    password
    sellStart
    sellEnd
    showUpcomingInfo
    ticketBlueprintIds
    link
    url
    active
  }
`;
